import React, {ReactNode} from 'react'
import {CSSTransition} from 'react-transition-group'
import {Header} from './Header'
import {Footer} from './Footer'
import {FixedCreateAccountButton} from './FixedCreateAccountButton'
import {useLocation} from 'react-router-dom'
import {HelpCenterHeader} from './HelpCenterHeader'
import LanguageToggle from './LanguageToggle'

type WrapperProps = {
  children: ReactNode
}

export const PublicWrapper: React.FC<WrapperProps> = ({children}) => {
  const {pathname} = useLocation()

  const showHelpCenterHeader = pathname.includes('/help-center') || pathname.includes('/contact-us')

  const showCreateAccountButton =
    pathname === '/' || pathname.includes('/products') || pathname.includes('/integrations')

  return (
    <>
      {showHelpCenterHeader ? <HelpCenterHeader /> : <Header />}
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <main style={{paddingTop: '96px', height: '100%'}}>{children}</main>
      </CSSTransition>
      {showCreateAccountButton && <FixedCreateAccountButton />}
      <Footer />
      <LanguageToggle />
    </>
  )
}
